module.exports = __webpack_public_path__ + "static/img/hardMRI2.3b2e1017.png";